import { bindEvent } from "./events.js";
export function cancelHelpHover(state) {
    state.cancelHover?.();
    state.cancelHover = undefined;
}
/** Only the actual trigger starts a preview, never its layout wrapper or popup. */
export function bindHelpHover(summary, state, sync, delayMs) {
    bindEvent(summary, "pointerenter", (event) => {
        if (event.pointerType !== "mouse")
            return;
        const trigger = event.currentTarget;
        const current = trigger.parentElement;
        const window = trigger.ownerDocument.defaultView;
        if (!window)
            return;
        cancelHelpHover(state);
        state.suppressed = false;
        state.anchor = { x: event.clientX, y: event.clientY };
        if (current.open)
            return;
        const open = () => {
            state.cancelHover = undefined;
            if (!current.isConnected || state.suppressed)
                return;
            state.hovered = true;
            sync(current);
        };
        const delay = Number.isFinite(delayMs) ? Math.max(0, delayMs) : 120;
        if (delay === 0)
            open();
        else {
            const timer = window.setTimeout(open, delay);
            state.cancelHover = () => window.clearTimeout(timer);
        }
    });
    bindEvent(summary, "pointermove", (event) => {
        if (event.pointerType === "mouse" && state.cancelHover)
            state.anchor = { x: event.clientX, y: event.clientY };
    });
    bindEvent(summary, "pointerleave", (event) => {
        if (event.pointerType === "mouse")
            cancelHelpHover(state);
    });
}
export function observeHelpHover(root, states, close) {
    const move = (event) => {
        if (event.pointerType !== "mouse")
            return;
        for (const details of Array.from(root.querySelectorAll(".e308-help-popover[open]"))) {
            const state = states.get(details.dataset.e308Key ?? "");
            if (!state)
                continue;
            const limit = state.moveDismissPx;
            const moved = state.anchor &&
                limit !== undefined &&
                Number.isFinite(limit) &&
                limit > 0 &&
                Math.hypot(event.clientX - state.anchor.x, event.clientY - state.anchor.y) >= limit;
            if (!moved && (state.pinned || state.focused))
                continue;
            const target = event.target;
            const overControl = details.querySelector("summary")?.contains(target);
            const overContent = details.querySelector(".e308-help-content")?.contains(target);
            if (moved || (!overControl && !overContent)) {
                cancelHelpHover(state);
                state.hovered = false;
                state.pinned = false;
                state.focused = false;
                details.dataset.helpPinned = "false";
                state.suppressed = true;
                close(details);
            }
        }
    };
    root.ownerDocument.addEventListener("pointermove", move);
    return () => {
        root.ownerDocument.removeEventListener("pointermove", move);
        for (const state of states.values())
            cancelHelpHover(state);
    };
}
//# sourceMappingURL=help-hover.js.map